import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "requirements"
    }}>{`Requirements`}</h1>
    <h2 {...{
      "id": "local-development"
    }}>{`Local Development`}</h2>
    <ol>
      <li parentName="ol">{`Node V10 (`}<a parentName="li" {...{
          "href": "https://nodejs.org/dist/latest-v10.x/"
        }}>{`https://nodejs.org/dist/latest-v10.x/`}</a>{`)`}</li>
      <li parentName="ol">{`Yarn (`}<a parentName="li" {...{
          "href": "https://yarnpkg.com/"
        }}>{`https://yarnpkg.com/`}</a>{`)`}</li>
      <li parentName="ol">{`Firebase (`}<a parentName="li" {...{
          "href": "https://firebase.google.com/"
        }}>{`https://firebase.google.com/`}</a>{`)`}</li>
      <li parentName="ol">{`Firebase Tools (`}<a parentName="li" {...{
          "href": "https://firebase.google.com/docs/cli"
        }}>{`https://firebase.google.com/docs/cli`}</a>{`)`}</li>
    </ol>
    <h2 {...{
      "id": "for-deployment-or-production"
    }}>{`For Deployment Or Production`}</h2>
    <ol>
      <li parentName="ol">{`Node V10 (`}<a parentName="li" {...{
          "href": "https://nodejs.org/dist/latest-v10.x/"
        }}>{`https://nodejs.org/dist/latest-v10.x/`}</a>{`)`}</li>
      <li parentName="ol">{`Yarn (`}<a parentName="li" {...{
          "href": "https://yarnpkg.com/"
        }}>{`https://yarnpkg.com/`}</a>{`)`}</li>
      <li parentName="ol">{`Firebase With Premium Plan (`}<a parentName="li" {...{
          "href": "https://firebase.google.com/"
        }}>{`https://firebase.google.com/`}</a>{`)`}</li>
      <li parentName="ol">{`Firebase Tools (`}<a parentName="li" {...{
          "href": "https://firebase.google.com/docs/cli"
        }}>{`https://firebase.google.com/docs/cli`}</a>{`)`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      